import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { useQuery, useMutation } from '@apollo/client';

import { GET_INFOUSER, LOGIN_MUTATION } from '@betwixt/common/graphql/user.js';

import { OAuth } from '@betwixt/common/utils/auth.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';

const Login = (props) => {
  const { gConfig } = props;
  const goto = new URLSearchParams(props.location.search).get('goto');
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [errors, setErrors] = useState({});
  const [isMounted, setIsMounted] = useState(true);

  const { data } = useQuery(GET_INFOUSER, {
    fetchPolicy: 'cache-first',
  });
  const [loginMutation] = useMutation(LOGIN_MUTATION);

  const User = data?.User;

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!User || !isMounted || !User.modulesActived?.length) {
      return;
    }

    const nextPath = goto
      ? `/${goto}${props.location.search}`
      : `/${User.modulesActived[0].routes.my.path}`;
    const currentPath = `${props.location.pathname}${props.location.search}`;

    if (currentPath !== nextPath) {
      props.history.replace(nextPath);
    }
  }, [User, goto, isMounted, props.history, props.location.pathname, props.location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username === null || password === null) return;

    const componentRef = {
      state: { username, password, errors },
      setState: (newState) => {
        if (isMounted) {
          setErrors(newState.errors || {});
        }
      },
      props: {
        ...props,
        mutate: loginMutation,
      },
    };

    await OAuth.automaticLogin(componentRef);
  };

  return (
    <main id="LoginPage" role="main">
      <Header pagename="login" gConfig={gConfig} />

      {errors.formError != null ? <div className="error"> {errors.formError} </div> : ''}

      <section data-pagename="login">
        <div className="container section primary mt-0">
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <div id="LoginPage" className="section col-md-12 col-sm-12 col-xs-12">
                <header>
                  <h3> {props.t('section.title')} </h3>
                  <p> {props.t('section.description')} </p>
                </header>

                <form onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group col-md-5">
                      <input
                        id="username"
                        name="username"
                        type="text"
                        className="form-control with-border"
                        placeholder={props.i18n.getResource(
                          props.i18n.language,
                          'global',
                          'username'
                        )}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                      {errors.emailError != null ? (
                        <div className="error"> {errors.emailError} </div>
                      ) : (
                        ''
                      )}
                    </div>

                    <div className="form-group col-md-5">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        className="form-control with-border"
                        placeholder={props.i18n.getResource(
                          props.i18n.language,
                          'global',
                          'password'
                        )}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {errors.passwordError != null ? (
                        <div className="error"> {errors.passwordError} </div>
                      ) : (
                        ''
                      )}
                    </div>

                    <div className="form-group col-md-2">
                      <button type="submit" className="btn btn-primary mb-2 w-100">
                        GO
                      </button>
                    </div>

                    {errors.genericError != null ? (
                      <div className="col-md-12 mb-4">
                        <div className="error genericError"> {errors.genericError} </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', margin: '30px' }}>
          <NavLink to="/signup">
            {' '}
            {props.i18n.getResource(props.i18n.language, 'global', 'signup_2')}{' '}
          </NavLink>
        </div>
      </section>

      <Footer i18n={props.i18n} without_logo={true} type="minimal_row" gConfig={gConfig} />
    </main>
  );
};

export default withRouter(withTranslation('login')(Login));

Login.propTypes = {
  gConfig: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getResource: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};
